import React, { useContext, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ConfigurationContext, TargetsContext, TestsContext, ApplicationStateContext } from "../../contexts";
import { LatencyDetail, JitterDetail } from ".";
import { ShadowBox, LatencyChart, JitterChart, Location } from "../common";
import { toInt } from "../../utilities";
import { UseTesting } from "../../hooks";
import { Status } from "./Status";
import { Row, Col } from "react-bootstrap";

//import ReactGA from "react-ga";

/**
 * DetailTesting component.
 *
 * Handles running the testing procedure and displaying the real time test results.
 */
export const DetailTesting = () => {
  const params = useParams(); // The URL parameters.
  const navigate = useNavigate();
  const { applicationState } = useContext(ApplicationStateContext);
  const targets = useContext(TargetsContext);
  const { dispatch } = useContext(TestsContext);
  const targetIndex = toInt(params.index);
  const { localTestTime, localTestLimit } = useContext(ConfigurationContext);

  /** Function: Handle the done testing event.
   */
  const onDoneTesting = useCallback(() => {
    // Go to the detail view.
    navigate(`/detail-test/${targetIndex}`);
  }, [targetIndex, navigate]);

  const { start } = UseTesting({ min: targetIndex, max: targetIndex }, localTestTime, localTestLimit, onDoneTesting);

  /** Function: Start the testing process.
   */
  const startTesting = useCallback(() => {
    dispatch({ type: "reset", index: targetIndex });
    start(onDoneTesting);
  }, [dispatch, targetIndex, start, onDoneTesting]);

  /** Effect: Reloads the page if ads are present.
   */
  useEffect(() => {
    // Reload the page if we're showing ads.
    if (applicationState.loadedAds) {
      window.location.reload(false);
      return;
    }
  }, [applicationState.loadedAds]);

  /** Effect: Start the testing process.
   */
  useEffect(() => {
    // Only start if there are no ads.
    if (!applicationState.loadedAds) {
      startTesting();
    }
  }, [applicationState.loadedAds, startTesting]);

  /** Function: Can or should we render this view?
   */
  const canRender = () => {
    // Check for no ads and that data is present.
    return !applicationState.loadedAds && targets && targets[targetIndex];
  };

  // Rendering

  if (!canRender()) {
    // Nothing to render.
    return null;
  }

  return (
    <>
      <div>
        <div className='my-4'>
          <Location index={targetIndex} />
        </div>
        <Row>
          <Col>
            <div className='text-dark text-start h4 me-2'>Latency</div>
            <ShadowBox className='p-2'>
              <div>
                <LatencyDetail index={targetIndex}></LatencyDetail>
              </div>
              <div>
                <LatencyChart index={targetIndex}></LatencyChart>
              </div>
            </ShadowBox>
          </Col>
          <Col>
            <div className='text-dark text-start h4 me-2'>Jitter</div>
            <ShadowBox className='p-2'>
              <div>
                <JitterDetail index={targetIndex} />
              </div>
              <div>
                <JitterChart index={targetIndex}></JitterChart>
              </div>
            </ShadowBox>
          </Col>
        </Row>
        <div className='m-3'>
          <Status targetIndex={targetIndex}></Status>
        </div>{" "}
      </div>
    </>
  );
};
